module.exports = "<div class=\"loader-wrap\" [ngClass]=\"(activeLoader | async)?'':'hidden'\">\r\n    <p-progressSpinner></p-progressSpinner>\r\n</div>"